export enum FecImportFileError {
  AlreadyImported = 'already_imported',
  FileTooLarge = 'file_too_large',
  InvalidFormat = 'invalid_format',
  UploadFailed = 'upload_failed',
}
